import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import BackIcon from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Close';

import Autocomplete from '../Autocomplete';

const SelectBoxList = (props) => {
  const {
    title,
    onBackClick,
    search,
    setSearch,
    onChange,
    searchLabel,
    searchPlaceholder = 'Search',
    options = [],
    getOptionLabel = (option) => option?.name,
    selected,
    renderSelectedItem,
    onRemoveItem,
    sx,
  } = props;

  return (
    <Box sx={sx}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <IconButton
            onClick={onBackClick}
            sx={(theme) => ({
              backgroundColor: 'var(--color-hover-surface)',
              color: theme.palette.text.primary,
              border: `1px solid ${theme.palette.divider}`,
              '&:hover': {
                backgroundColor: 'var(--color-main-light)',
              },
            })}
          >
            <BackIcon fontSize="small" />
          </IconButton>
        </Box>
        <Typography sx={{ flex: 1, ml: 1, textAlign: 'center', fontWeight: 600 }}>{title}</Typography>
        <Box sx={{ flex: 1 }} />
      </Box>

      <Autocomplete
        value={null}
        inputValue={search}
        onChange={onChange}
        onInputChange={(e, v, reason) => {
          if (reason === 'reset') return;
          setSearch(v);
        }}
        placeholder={searchPlaceholder}
        label={searchLabel}
        options={options}
        getOptionLabel={getOptionLabel}
      />

      <Box sx={{ mt: 2 }}>
        {selected.map((item) => (
          <Box key={item?.id} sx={{ display: 'flex', mb: 0.5, alignItems: 'center', justifyContent: 'space-between' }}>
            {renderSelectedItem ? renderSelectedItem(item) : (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ fontSize: 14 }}>
                  {item.name}
                </Typography>
                {!!item?.description && (
                  <Typography sx={{ fontSize: 14, ml: 1, color: 'var(--color-text-muted)' }}>
                    {item?.description}
                  </Typography>
                )}
              </Box>
            )}
            <IconButton aria-label="delete" color="error" onClick={() => onRemoveItem(item.id)} size="small">
              <DeleteIcon fontSize="small" color="error" />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SelectBoxList;
